import React, { useState, useEffect } from "react";
import { Row, Col } from "reactstrap";
import axios from "axios";
import CountUp from "react-countup";
import Widget from "../../../../../components/Widget/Widget";

const PageAnalytics = () => {
  const [anaData, setAnaData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchData = async (firstLoad) => {
    if(firstLoad){
      setLoading(true);
    }
    try {
      const response = await axios.get(
        "https://eadash.arabiansystems.com/api/Analytics"
      );
      const data = response.data.analytics;
      setAnaData(data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData(true);
    const interval = setInterval(() => {
      fetchData(false);
    }, 60000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Widget fetchingData={loading}>
      <div className="clearfix height150 relativeDiv">
        <Row className="flex-nowrap">
          <Col xs={3}>
            <img src="/icons/googleanalyt.png" width="40" />
          </Col>
          <Col xs={9}>
            <h6 className="m-0">Visits</h6>
            {/* <p className="h2 m-0 fw-normal">
              <CountUp
                start={0}
                end={anaData?.users}
                duration={2}
                separator=","
                enableScrollSpy
              />
            </p> */}
          </Col>
        </Row>
        <Row className="flex-nowrap marginTop36">
          <Col xs="4">
            <h6 className="m-0 font12">New</h6>
            <p className="value6 fontCustom">
              <CountUp
                start={0}
                end={anaData?.newUsers}
                duration={2}
                separator=","
                enableScrollSpy
              />
            </p>
          </Col>
          <Col xs={4}>
            <h6 className="m-0 font12" >Returning</h6>
            <p className="value6 fontCustom">
              <CountUp
                start={0}
                end={anaData?.returningUsers}
                duration={2}
                separator=","
                enableScrollSpy
              />
            </p>
          </Col>

          <Col xs={4}>
            <h6 className="m-0 font12" >Engagement</h6>
            <p className="value6 fontCustom">
            {anaData?.averageEngagement}
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <div className="marginTop10 infoFlex absoDiv">
              <i class="fa fa-info-circle"></i>
              <p className="m-0">Based on data from the last 30 days</p>
            </div>
          </Col>
        </Row>
      </div>
    </Widget>
  );
};

export default PageAnalytics;
